import type { OutreachWorkflowDefaults } from '../types';
import {
  OutreachWorkflow,
  OutreachWorkflowStage,
  OutreachWorkflowStagePartnerEval,
} from '../models';
import type { AxiosRequestConfig } from 'axios';
import { ModelResource } from './resource';

export class OutreachWorkflows extends ModelResource<OutreachWorkflow> {
  model = OutreachWorkflow;

  resourcePath = 'v1/outreach-workflows';

  async createStage(
    workflowId: string,
    data: { phone_number?: string },
    workflow?: OutreachWorkflow,
  ): Promise<OutreachWorkflowStage> {
    if (workflow && workflow.id !== workflowId) {
      throw Error(`${workflowId} does not match provided outreach workflow with id ${workflow.id}`);
    }

    return this.api.post(this.path(workflowId, 'stages'), { data }).then((response) => {
      const schedule = OutreachWorkflowStage.fromJson(response.data);
      if (workflow) {
        workflow.stages.push(schedule);
      }

      return schedule;
    });
  }

  async updateStage(
    schedule: OutreachWorkflowStage,
    data: { phone_number?: string },
  ): Promise<OutreachWorkflowStage> {
    return this.api
      .post(this.path(schedule.workflow_id, 'stages', schedule.id), { data })
      .then((response) => {
        schedule.updateFromJson(response.data);
        return schedule;
      });
  }

  async deleteStage(schedule: OutreachWorkflowStage): Promise<any> {
    return this.api.delete(this.path(schedule.workflow_id, 'stages', schedule.id));
  }

  async getDefaults(
    workflowId: string,
    params: { action: string },
  ): Promise<OutreachWorkflowDefaults> {
    return this.api
      .get(this.path(workflowId, 'defaults'), { params })
      .then((response) => response.data);
  }

  async getMatchedCustomers(workflow: OutreachWorkflow): Promise<number> {
    const response = await this.api.get(this.path(workflow.id, 'total-matched-customers'));

    return response.data.total_customers;
  }
}

export class OutreachWorkflowStagePartnerEvals extends ModelResource<OutreachWorkflowStagePartnerEval> {
  model = OutreachWorkflowStagePartnerEval;

  resourcePath = 'v1/outreach-workflows/partner-stage-evals';
}
